import NewsList from './news-list/news-list.vue';
import NewsDetail from './news-detail/news-detail.vue';
import newsDetailRecommend from './news-detail-recommend/news-detail-recommend.vue';

export default [
  {
    path: 'news-list/:type',
    name: 'newsList',
    component: NewsList,
    meta: {
      title: '市内动态',
      breadCrumbShowIndexArr: [0, 1]  // 面包屑
    }
  },
  {
    path: 'news-detail',
    name: 'newsDetail',
    component: NewsDetail,
    meta: {
      title: '新闻详情',
      breadCrumbShowIndexArr: [0, 1, 3]
    }
  },
  {
    path: 'news-detail-recommend',
    name: 'newsDetailRecommend',
    component: newsDetailRecommend,
    meta: {
      title: '新闻详情'
    }
  }
];
